import { get } from '../../../../../shared/api';
import { DefaultResponseDTO } from '../../../../../shared/constants';

export const getPrivacyRequest = (): Promise<DefaultResponseDTO<string>> => {
  return get<DefaultResponseDTO<string>>(`/terms/privacy-policy`);
};
